/**
 * Reads the claims of a JWT without verifying it — client-side UI decisions only (e.g. showing admin tools).
 * Same claims as Clerk's useAuth().sessionClaims, usable outside React hooks (class components).
 */
export default class JwtClaimsReader {
    /**
     * @param {string|null} token
     * @returns {object|null} claims, null when the token is missing or malformed
     */
    static read(token) {
        if (!token) return null;

        const parts = token.split('.');
        if (parts.length !== 3) return null;

        try {
            return JSON.parse(atob(JwtClaimsReader._toBase64(parts[1])));
        } catch {
            return null;
        }
    }

    // base64url → base64 with padding
    static _toBase64(part) {
        const base64 = part.replace(/-/g, '+').replace(/_/g, '/');
        return base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');
    }
}
